import React, { useEffect, useState } from 'react'
import Discuss from './discuss/Discuss'
import { DiscussionProps } from '../../../../../types/course-construction'
import dayjs from 'dayjs'
import useKeyword from '../../../../../hooks/useKeyword'
import { isEmpty, toNumber } from 'lodash'
import { getSavedDiscussion } from '../../../../../service/course-management'
import { Spin } from 'antd'
import { CourseManagementStore } from '../../../../../stores/stores'

type FilterData = {
	student: string,
	timeCreated: any
}
interface Props {
	filterData: FilterData
}
const DiscussionSaved = (props: Props) => {
const { filterData } = props
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const unitId = toNumber(useKeyword("unitId"));
	const { reloadDiscussion } = CourseManagementStore()

	useEffect(() => {
		const getComments = async () => {
			setIsLoading(true);

			try {
				if (unitId) {

					let res: any = {};

					res = await getSavedDiscussion({
						unitId: unitId,
						keyword: filterData.student,
						createdDateFrom: !isEmpty(filterData?.timeCreated)
							? dayjs(filterData?.timeCreated?.[0])
								.toISOString()
							: undefined,
						createdDateTo: !isEmpty(filterData?.timeCreated)
							? dayjs(filterData?.timeCreated?.[1])
								.toISOString()
							: undefined,
					});
					setComments(res.data.data);
				}
			} catch (error) {

			}
			finally {
				setIsLoading(false);
			}
		};
		getComments();
	}, [unitId, filterData, reloadDiscussion]);

	const [comments, setComments] = useState<{
		total: number;
		discussions: DiscussionProps[];
	}>();
	return (
		<Spin spinning={isLoading}>
			<div className="discussion-course flex gap-3">
				< Discuss comments={comments} />
			</div>
		</Spin>

	)
}

export default DiscussionSaved